<template>
    <div class="title-line text-bold font14px">{{title}}</div>
</template>

<script>
    export default {
        name: "TitleLine",
        props:['title'],
    }
</script>

<style lang="scss" scoped>
    .title-line{
        background-color: #f2f2f2;
        padding: 10px 20px;
        border-radius: 3px;
    }
</style>
